import { QuestionCircleOutlined } from "@ant-design/icons";
import { Row, Col, Select, Input, Tooltip } from "antd";
import React, { useState } from "react";

const { Option } = Select;
function FileToSpecTask(props) {
  const [matchDisabled, setMatchDisabled] = useState(false);
  return (
    <div>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">Test Suite *</p>
        </Col>
        <Col span={18}>
          <Select
            style={{ width: "100%" }}
            placeholder="select test suite"
            onChange={(e, id) => {
              props.updateTestSuiteName(id.children);
              props.updateTestSuiteId(e);
            }}
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {props.testSuiteList.map((item) => (
              <Option key={item.testSuiteId} value={item.testSuiteId}>
                {item.testSuiteName}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Match Filename *{" "}
            <Tooltip title="Enter the name of the file which should match the criteria from dropdown selection">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={6}>
          <Select
            placeholder="match type"
            onChange={(e) => {
              if (e === "any") {
                props.updateMatchFileName("");
                setMatchDisabled(true);
              } else {
                setMatchDisabled(false);
              }
              props.updateMatchType(e);
            }}
            style={{ width: "80%" }}
          >
            <Option value="equals">Equals</Option>
            <Option value="contains">Contains</Option>
            <Option value="any">Any</Option>
          </Select>
        </Col>
        <Col span={12}>
          <Input
            placeholder="file name"
            disabled={matchDisabled}
            onChange={(e) => props.updateMatchFileName(e.target.value)}
          />
        </Col>
      </Row>
    </div>
  );
}

export default FileToSpecTask;
